// The pending merchant offer, read off the snapshot.
//
// The offer lives on the harbour city in the snapshot (`seaOffer`), so the
// client never keeps its own copy of it: when the offer is answered — or
// times out — it leaves the snapshot and the toast goes with it. A missed
// event can therefore never leave a stale offer on screen.
import type { SceneNode } from '@aod/protocol';
import { cityOwnerId } from '../ownership.js';
import type { SeaOffer } from './offer.js';

export interface PendingMerchantOffer {
  /** The harbour the house is calling on. */
  readonly cityId: string;
  readonly offer: SeaOffer;
}

/** The local player's harbour with a house at it, if any. */
export function findPendingMerchantOffer(
  snapshot: { readonly scene: { readonly children?: readonly SceneNode[] } } | null,
  localPlayerIndex: number,
): PendingMerchantOffer | null {
  if (!snapshot) return null;
  for (const node of snapshot.scene.children ?? []) {
    if (node.type !== 'city') continue;
    if (cityOwnerId(node.props) !== localPlayerIndex) continue;
    const offer = node.props?.seaOffer as SeaOffer | undefined;
    if (offer) return { cityId: node.id, offer };
  }
  return null;
}

/** A city node with an offer on it (test helper). */
export function cityWithOffer(id: string, ownerId: number, offer: SeaOffer): SceneNode {
  return {
    id,
    type: 'city',
    name: null,
    tags: null,
    transform: { position: [0, 0, 0], rotation: null, scale: null },
    bounds: null,
    visual: null,
    props: { ownerId, seaOffer: offer },
  } as unknown as SceneNode;
}
